import {connect} from 'react-redux';
import {
  loginUserSuccess,
  completeTokenLoading,
  loginCSRFUserSuccess,
  refreshFromCookie,
} from 'go/actions/api/auth';

import {TokenGate} from 'app-ui-componentlibrary/dist/componentLibrary/conditionGates/TokenGate';

export const mapStateToProps = (state) => {
  return {
    tokenStatus: state.auth.status,
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    setToken: (token) => {
      const action = loginUserSuccess(token);
      return dispatch(action);
    },
    setBlankToken: () => {
      const action = completeTokenLoading();
      return dispatch(action);
    },
    setCSRFToken: (payload) => {
      const action = loginCSRFUserSuccess(payload);
      return dispatch(action);
    },
    refresh: () => {
      const action = refreshFromCookie();
      const response = dispatch(action);
      return response;
    },
  };
};

const ConnectedTokenGate = connect(mapStateToProps, mapDispatchToProps)(TokenGate);

export default ConnectedTokenGate;
